<div class="container-fluid mt-2">
    <div class="p-4 rounded">
        <div class="row justify-content-center">
            <!-- Titulo -->
            <h5 class="text-secondary">Respuesta de Crédito</h5>
            <!-- Separador -->
            <hr width="90%">
        </div>
        <form [formGroup]="forma">
            <div class="card-header" role="tab" id="tituloSolicitud" data-toggle="collapse" data-target="#infoSolicitud"
                aria-expanded="false" aria-controls="infoSolicitud">
                <h4 class="mb-0">Información de la solicitud</h4>
            </div>
            <div id="infoSolicitud" class="card-body collapse show" role="tabpanel" aria-labelledby="tituloSolicitud">
                <div class="row justify-content-center">
                    <div class="col-sm-12 col-md-5 col-lg-5 form-group">
                        <label class="col-form-label col-form-label-sm">Ciente</label>
                        <input type="text" class="form-control form-control-sm" formControlName="nombreCliente" disabled>
                    </div>
                    <div class="col-sm-12 col-md-3 col-lg-3 form-group">
                        <label class="col-form-label col-form-label-sm">No. identificación</label>
                        <input type="text" class="form-control form-control-sm" formControlName="nroIdentificacion" disabled>
                    </div>
                    <div class="col-sm-12 col-md-3 col-lg-3 form-group">
                        <label class="col-form-label col-form-label-sm">No. solicitud</label>
                        <input type="text" class="form-control form-control-sm" formControlName="nroSolicitud" disabled>
                    </div>
                </div>
            </div>
            <div class="card-header" role="tab" id="tituloRespuesta" data-toggle="collapse" data-target="#infoRespuesta"
                aria-expanded="false" aria-controls="infoRespuesta">
                <h4 class="mb-0">Respuesta análisis de capacidad de pago</h4>
            </div>
            <div id="infoRespuesta" class="card-body collapse show" role="tabpanel" aria-labelledby="tituloRespuesta">
                <div class="row justify-content-left">
                    <div class="col-sm-12 col-md-6 col-lg-3 form-group">
                        <label class="col-form-label col-form-label-sm">Fecha respuesta estudio</label>
                        <div class="input-group">
                            <input type="text" class="form-control form-control-sm text-center" placeholder="Día/Mes/Año"
                                ngbDatepicker #d="ngbDatepicker" (click)="d.toggle()" formControlName="respuestaDate" disabled/>
                            <button type="button" class="btn btn-info btn-sm" (click)="d.toggle()" disabled>
                                <i class="fa fa-calendar"></i>
                            </button>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-3 form-group" [ngClass]="{ 'text-danger': respuestaEstudio.invalid && respuestaEstudio.touched }">
                        <label class="col-form-label col-form-label-sm">Respuesta estudio</label>
                        <ng-select class="custom" loadingText="Cargando por favor espere..."
                            [clearable]="false" [searchable]="false" placeholder="Selecciona"
                            [(ngModel)]="resEstudio" formControlName="respuestaEstudio" [loading]="loadValues" required (blur)="saveForm(forma, formIdentifier)">
                            <ng-option *ngFor="let acc of respuestaOpc" [value]="acc.valueId">
                                {{ acc.name }}
                            </ng-option>
                        </ng-select>
                        <div *ngIf="respuestaEstudio.errors && (respuestaEstudio.dirty || respuestaEstudio.touched)">
                          <span *ngIf="respuestaEstudio.errors.required">Requerido</span>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-3 form-group" [ngClass]="{ 'text-danger': seguroCredito.invalid && seguroCredito.touched }">
                        <label class="col-form-label col-form-label-sm">Aplica seguro de crédito</label>
                        <ng-select class="custom" loadingText="Cargando por favor espere..."
                            [clearable]="false" [searchable]="false" placeholder="Selecciona"
                            [(ngModel)]="segCredito" formControlName="seguroCredito" required>
                            <ng-option *ngFor="let acc of creditoYoN" [value]="acc.value">
                                {{ acc.name }}
                            </ng-option>
                        </ng-select>
                        <div *ngIf="seguroCredito.errors && (seguroCredito.dirty || seguroCredito.touched)">
                          <span *ngIf="seguroCredito.errors.required">Requerido</span>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-3 form-group" [ngClass]="{ 'text-danger': estructuraAprobacion.invalid && estructuraAprobacion.touched }">
                        <label class="col-form-label col-form-label-sm">Estructura aprobación</label>
                        <!-- <ng-select class="custom" loadingText="Cargando por favor espere..." [loading]="loadValues"
                            [clearable]="false" [searchable]="false" placeholder="Selecciona" multiple="true"
                            [(ngModel)]="estAprobacion" formControlName="estructuraAprobacion"
                            [readonly]="respuestaEstudio.value != '1'" [required]="respuestaEstudio.value == '1'" (change)="estructuraAprobada()">
                            <ng-option *ngFor="let acc of aprobacionOpc" [value]="acc.valueId" (click)="estructuraAprobada()">
                                {{ acc.name }}
                            </ng-option>
                        </ng-select> -->
                        <ng-select

                            [items]="aprobacionOpc"
                            [clearSearchOnAdd]="true"
                            [closeOnSelect]="false"
                            labelForId="state"
                            [multiple]="true"
                            placeholder="Selecciona"
                            [loading]="loadValues"
                            loadingText="Cargando, por favor espere..."
                            clearAllText="Limpiar"
                            formControlName="estructuraAprobacion"
                            [bindValue]="'valueId'"
                            [bindLabel]="'name'"
                            class="custom-multi"
                            (change)="estructuraAprobada()"
                            (blur)="saveForm(forma, formIdentifier)"
                            (clear)="onClear()"
                            >
                            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <div class="row" style="width: fit-content; margin-left: 0px">
                                <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected" [disabled]="item.valueId === 'D1'" [ngModelOptions]="{standalone: true}" style="margin-right: 10px"/>
                            {{item['name']}}
                            </div>
                            </ng-template>
                            <ng-template ng-multi-label-tmp let-items="items">
                            <div class="ng-value" *ngFor="let item of items">
                                {{item['name']}}
                            </div>
                            </ng-template>
                        </ng-select>
                        <div *ngIf="estructuraAprobacion.errors && (estructuraAprobacion.dirty || estructuraAprobacion.touched)">
                          <span *ngIf="estructuraAprobacion.errors.required">Requerido</span>
                        </div>
                    </div>
                    <div *ngIf="estructuraAprobacion.value?.includes('D1') && respuestaEstudio.value == '1'" class="col-sm-12 col-md-6 col-lg-3 form-group" [ngClass]="{ 'text-danger': nombresD1.invalid && nombresD1.touched }">
                        <label class="col-form-label col-form-label-sm">{{ personType == 'Natural' ? "Nombres (Deudor 1)" : "Nombre (Deudor 1)" }} </label>
                        <input type="text" class="form-control form-control-sm" [required]="D1 && respuestaEstudio.value == '1'" formControlName="nombresD1" [imask]="nameMask" (blur)="saveForm(forma, formIdentifier)">
                        <div *ngIf="nombresD1.errors && (nombresD1.dirty || nombresD1.touched)">
                          <span *ngIf="nombresD1.errors.required">Requerido</span>
                        </div>
                    </div>
                    <div *ngIf="estructuraAprobacion.value?.includes('D1') && respuestaEstudio.value == '1' && personType == 'Natural'" class="col-sm-12 col-md-6 col-lg-3 form-group" [ngClass]="{ 'text-danger': apellidosD1.invalid && apellidosD1.touched }">
                        <label class="col-form-label col-form-label-sm">Apellidos (Deudor 1)</label>
                        <input type="text" class="form-control form-control-sm" [required]="D1 && respuestaEstudio.value == '1' && personType == 'Natural'" formControlName="apellidosD1" [imask]="nameMask" (blur)="saveForm(forma, formIdentifier)">
                        <div *ngIf="apellidosD1.errors && (apellidosD1.dirty || apellidosD1.touched)">
                          <span *ngIf="apellidosD1.errors.required">Requerido</span>
                        </div>
                    </div>
                    <div *ngIf="estructuraAprobacion.value?.includes('D2') && respuestaEstudio.value == '1'" class="col-sm-12 col-md-6 col-lg-3 form-group" [ngClass]="{ 'text-danger': nombresD2.invalid && nombresD2.touched }">
                        <label class="col-form-label col-form-label-sm">Nombres (Deudor 2)</label>
                        <input type="text" class="form-control form-control-sm" [required]="D2 && respuestaEstudio.value == '1'" formControlName="nombresD2" [imask]="nameMask" (blur)="saveForm(forma, formIdentifier)">
                        <div *ngIf="nombresD2.errors && (nombresD2.dirty || nombresD2.touched)">
                          <span *ngIf="nombresD2.errors.required">Requerido</span>
                        </div>
                    </div>
                    <div *ngIf="estructuraAprobacion.value?.includes('D2') && respuestaEstudio.value == '1'" class="col-sm-12 col-md-6 col-lg-3 form-group" [ngClass]="{ 'text-danger': apellidosD2.invalid && apellidosD2.touched }">
                        <label class="col-form-label col-form-label-sm">Apellidos (Deudor 2)</label>
                        <input type="text" class="form-control form-control-sm" [required]="D2 && respuestaEstudio.value == '1'" formControlName="apellidosD2" [imask]="nameMask" (blur)="saveForm(forma, formIdentifier)">
                        <div *ngIf="apellidosD2.errors && (apellidosD2.dirty || apellidosD2.touched)">
                          <span *ngIf="apellidosD2.errors.required">Requerido</span>
                        </div>
                    </div>
                    <div *ngIf="estructuraAprobacion.value?.includes('C1') && respuestaEstudio.value == '1'" class="col-sm-12 col-md-6 col-lg-4 form-group" [ngClass]="{ 'text-danger': nombresCD1.invalid && nombresCD1.touched }">
                        <label class="col-form-label col-form-label-sm">Nombres (Codeudor 1)</label>
                        <input type="text" class="form-control form-control-sm" [required]="CD1 && respuestaEstudio.value == '1'" formControlName="nombresCD1" [imask]="nameMask" (blur)="saveForm(forma, formIdentifier)">
                        <div *ngIf="nombresCD1.errors && (nombresCD1.dirty || nombresCD1.touched)">
                          <span *ngIf="nombresCD1.errors.required">Requerido</span>
                        </div>
                    </div>
                    <div *ngIf="estructuraAprobacion.value?.includes('C1') && respuestaEstudio.value == '1'" class="col-sm-12 col-md-6 col-lg-4 form-group" [ngClass]="{ 'text-danger': apellidosCD1.invalid && apellidosCD1.touched }">
                        <label class="col-form-label col-form-label-sm">Apellidos (Codeudor 1)</label>
                        <input type="text" class="form-control form-control-sm" [required]="CD1 && respuestaEstudio.value == '1'" formControlName="apellidosCD1" [imask]="nameMask" (blur)="saveForm(forma, formIdentifier)">
                        <div *ngIf="apellidosCD1.errors && (apellidosCD1.dirty || apellidosCD1.touched)">
                          <span *ngIf="apellidosCD1.errors.required">Requerido</span>
                        </div>
                    </div>
                    <div *ngIf="estructuraAprobacion.value?.includes('C1')" class="col-sm-12 col-md-4 col-lg-4">
                        <div class="form-group" [ngClass]="{ 'text-danger': documentNumberCD1.invalid && documentNumberCD1.touched }">
                          <label class="col-form-label col-form-label-sm">No. identificación (Codeudor 1)</label>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <ng-select
                                [items]="tiposIdentidad"
                                bindValue="valueId"
                                bindLabel="valueId"
                                class="custom"
                                [loading]="tiposIdentidad.length === 0"
                                loadingText="Cargando por favor espere..."
                                [clearable]="false"
                                [searchable]="false"
                                formControlName="typeOfIdentityCD1">
                              </ng-select>
                            </div>
                            <input type="text" class="form-control form-control-sm" formControlName="documentNumberCD1" [required]="CD1" [imask]="onlyNumberMask" (blur)="saveForm(forma, formIdentifier)">
                          </div>
                          <div *ngIf="documentNumberCD1.errors && (documentNumberCD1.dirty || documentNumberCD1.touched)">
                            <span *ngIf="documentNumberCD1.errors.required">Requerido</span>
                          </div>
                        </div>
                      </div>
                    <div *ngIf="estructuraAprobacion.value?.includes('C2') && respuestaEstudio.value == '1'" class="col-sm-12 col-md-6 col-lg-4 form-group" [ngClass]="{ 'text-danger': nombresCD2.invalid && nombresCD2.touched }">
                        <label class="col-form-label col-form-label-sm">Nombres (Codeudor 2)</label>
                        <input type="text" class="form-control form-control-sm" [required]="CD2 && respuestaEstudio.value == '1'" formControlName="nombresCD2" [imask]="nameMask" (blur)="saveForm(forma, formIdentifier)">
                        <div *ngIf="nombresCD2.errors && (nombresCD2.dirty || nombresCD2.touched)">
                          <span *ngIf="nombresCD2.errors.required">Requerido</span>
                        </div>
                    </div>
                    <div *ngIf="estructuraAprobacion.value?.includes('C2') && respuestaEstudio.value == '1'" class="col-sm-12 col-md-6 col-lg-4 form-group" [ngClass]="{ 'text-danger': apellidosCD2.invalid && apellidosCD2.touched }">
                        <label class="col-form-label col-form-label-sm">Apellidos (Codeudor 2)</label>
                        <input type="text" class="form-control form-control-sm" [required]="CD2 && respuestaEstudio.value == '1'" formControlName="apellidosCD2" [imask]="nameMask" (blur)="saveForm(forma, formIdentifier)">
                        <div *ngIf="apellidosCD2.errors && (apellidosCD2.dirty || apellidosCD2.touched)">
                          <span *ngIf="apellidosCD2.errors.required">Requerido</span>
                        </div>
                    </div>
                    <div *ngIf="estructuraAprobacion.value?.includes('C2')" class="col-sm-12 col-md-4 col-lg-4">
                        <div class="form-group" [ngClass]="{ 'text-danger': documentNumberCD2.invalid && documentNumberCD2.touched }">
                          <label class="col-form-label col-form-label-sm">No. identificación (Codeudor 2)</label>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <ng-select
                                [items]="tiposIdentidad"
                                bindValue="valueId"
                                bindLabel="valueId"
                                class="custom"
                                [loading]="tiposIdentidad.length === 0"
                                loadingText="Cargando por favor espere..."
                                [clearable]="false"
                                [searchable]="false"
                                formControlName="typeOfIdentityCD2">
                              </ng-select>
                            </div>
                            <input type="text" class="form-control form-control-sm" formControlName="documentNumberCD2" [required]="CD2" [imask]="onlyNumberMask" (blur)="saveForm(forma, formIdentifier)">
                          </div>
                          <div *ngIf="documentNumberCD2.errors && (documentNumberCD2.dirty || documentNumberCD2.touched)">
                            <span *ngIf="documentNumberCD2.errors.required">Requerido</span>
                          </div>
                        </div>
                      </div>
                    <div class="col-sm-12 col-md-12 col-lg-6 form-group" [ngClass]="{ 'text-danger': motivoAplazamiento.invalid && motivoAplazamiento.touched }">
                        <label class="col-form-label col-form-label-sm">Motivo aplazamiento (Deudor 1)</label>
                        <!-- <ng-select class="custom" loadingText="Cargando por favor espere..." [loading]="loadValues"
                            [clearable]="false" [searchable]="false" placeholder="Selecciona"
                            [(ngModel)]="motAplazamiento" formControlName="motivoAplazamiento" required>
                            <ng-option *ngFor="let acc of aplazamientoOpc" [value]="acc.valueId">
                                {{ acc.name }}
                            </ng-option>
                        </ng-select> -->
                        <ng-select
                            [items]="aplazamientoOpc"
                            [clearSearchOnAdd]="true"
                            [closeOnSelect]="false"
                            labelForId="state"
                            [multiple]="true"
                            placeholder="Selecciona"
                            [loading]="loadValues"
                            loadingText="Cargando, por favor espere..."
                            clearAllText="Limpiar"
                            formControlName="motivoAplazamiento"
                            [bindValue]="'valueId'"
                            [bindLabel]="'name'"
                            class="custom-multi"
                            (blur)="saveForm(forma, formIdentifier)"
                            [readonly]="respuestaEstudio.value !== '2' || !D1"
                            [required]="respuestaEstudio.value === '2' && D1">
                            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <div class="row" style="width: fit-content; margin-left: 0px">
                                <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected" [ngModelOptions]="{standalone: true}" style="margin-right: 10px"/>
                            {{item['name']}}
                            </div>
                            </ng-template>
                            <ng-template ng-multi-label-tmp let-items="items">
                            <div class="ng-value" *ngFor="let item of items">
                                {{item['name']}}
                            </div>
                            </ng-template>
                        </ng-select>
                        <div *ngIf="motivoAplazamiento.errors && (motivoAplazamiento.dirty || motivoAplazamiento.touched)">
                          <span *ngIf="motivoAplazamiento.errors.required">Requerido</span>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-6 form-group" [ngClass]="{ 'text-danger': motivoAplazamientoD2.invalid && motivoAplazamientoD2.touched }">
                        <label class="col-form-label col-form-label-sm">Motivo aplazamiento (Deudor 2)</label>
                        <!-- <ng-select class="custom" loadingText="Cargando por favor espere..." [loading]="loadValues"
                            [clearable]="false" [searchable]="false" placeholder="Selecciona"
                            [(ngModel)]="motAplazamiento" formControlName="motivoAplazamiento" required>
                            <ng-option *ngFor="let acc of aplazamientoOpc" [value]="acc.valueId">
                                {{ acc.name }}
                            </ng-option>
                        </ng-select> -->
                        <ng-select
                            [items]="aplazamientoOpc"
                            [clearSearchOnAdd]="true"
                            [closeOnSelect]="false"
                            labelForId="state"
                            [multiple]="true"
                            placeholder="Selecciona"
                            [loading]="loadValues"
                            loadingText="Cargando, por favor espere..."
                            clearAllText="Limpiar"
                            formControlName="motivoAplazamientoD2"
                            [bindValue]="'valueId'"
                            [bindLabel]="'name'"
                            class="custom-multi"
                            (blur)="saveForm(forma, formIdentifier)"
                            [readonly]="respuestaEstudio.value !== '2' || !D2"
                            [required]="respuestaEstudio.value === '2' && D2">
                            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <div class="row" style="width: fit-content; margin-left: 0px">
                                <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected" [ngModelOptions]="{standalone: true}" style="margin-right: 10px"/>
                            {{item['name']}}
                            </div>
                            </ng-template>
                            <ng-template ng-multi-label-tmp let-items="items">
                            <div class="ng-value" *ngFor="let item of items">
                                {{item['name']}}
                            </div>
                            </ng-template>
                        </ng-select>
                        <div *ngIf="motivoAplazamientoD2.errors && (motivoAplazamientoD2.dirty || motivoAplazamientoD2.touched)">
                          <span *ngIf="motivoAplazamientoD2.errors.required">Requerido</span>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-6 form-group" [ngClass]="{ 'text-danger': motivoAplazamientoCD1.invalid && motivoAplazamientoCD1.touched }">
                        <label class="col-form-label col-form-label-sm">Motivo aplazamiento (Codeudor 1)</label>
                        <!-- <ng-select class="custom" loadingText="Cargando por favor espere..." [loading]="loadValues"
                            [clearable]="false" [searchable]="false" placeholder="Selecciona"
                            [(ngModel)]="motAplazamiento" formControlName="motivoAplazamiento" required>
                            <ng-option *ngFor="let acc of aplazamientoOpc" [value]="acc.valueId">
                                {{ acc.name }}
                            </ng-option>
                        </ng-select> -->
                        <ng-select
                            [items]="aplazamientoOpc"
                            [clearSearchOnAdd]="true"
                            [closeOnSelect]="false"
                            labelForId="state"
                            [multiple]="true"
                            placeholder="Selecciona"
                            [loading]="loadValues"
                            loadingText="Cargando, por favor espere..."
                            clearAllText="Limpiar"
                            formControlName="motivoAplazamientoCD1"
                            [bindValue]="'valueId'"
                            [bindLabel]="'name'"
                            class="custom-multi"
                            (blur)="saveForm(forma, formIdentifier)"
                            [readonly]="respuestaEstudio.value !== '2' || !CD1"
                            [required]="respuestaEstudio.value === '2' && CD1">
                            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <div class="row" style="width: fit-content; margin-left: 0px">
                                <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected" [ngModelOptions]="{standalone: true}" style="margin-right: 10px"/>
                            {{item['name']}}
                            </div>
                            </ng-template>
                            <ng-template ng-multi-label-tmp let-items="items">
                            <div class="ng-value" *ngFor="let item of items">
                                {{item['name']}}
                            </div>
                            </ng-template>
                        </ng-select>
                        <div *ngIf="motivoAplazamientoCD1.errors && (motivoAplazamientoCD1.dirty || motivoAplazamientoCD1.touched)">
                          <span *ngIf="motivoAplazamientoCD1.errors.required">Requerido</span>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-6 form-group" [ngClass]="{ 'text-danger': motivoAplazamientoCD2.invalid && motivoAplazamientoCD2.touched }">
                        <label class="col-form-label col-form-label-sm">Motivo aplazamiento (Codeudor 2)</label>
                        <!-- <ng-select class="custom" loadingText="Cargando por favor espere..." [loading]="loadValues"
                            [clearable]="false" [searchable]="false" placeholder="Selecciona"
                            [(ngModel)]="motAplazamiento" formControlName="motivoAplazamiento" required>
                            <ng-option *ngFor="let acc of aplazamientoOpc" [value]="acc.valueId">
                                {{ acc.name }}
                            </ng-option>
                        </ng-select> -->
                        <ng-select
                            [items]="aplazamientoOpc"
                            [clearSearchOnAdd]="true"
                            [closeOnSelect]="false"
                            labelForId="state"
                            [multiple]="true"
                            placeholder="Selecciona"
                            [loading]="loadValues"
                            loadingText="Cargando, por favor espere..."
                            clearAllText="Limpiar"
                            formControlName="motivoAplazamientoCD2"
                            [bindValue]="'valueId'"
                            [bindLabel]="'name'"
                            class="custom-multi"
                            (blur)="saveForm(forma, formIdentifier)"
                            [readonly]="respuestaEstudio.value !== '2' || !CD2"
                            [required]="respuestaEstudio.value === '2' && CD2">
                            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <div class="row" style="width: fit-content; margin-left: 0px">
                                <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected" [ngModelOptions]="{standalone: true}" style="margin-right: 10px"/>
                            {{item['name']}}
                            </div>
                            </ng-template>
                            <ng-template ng-multi-label-tmp let-items="items">
                            <div class="ng-value" *ngFor="let item of items">
                                {{item['name']}}
                            </div>
                            </ng-template>
                        </ng-select>
                        <div *ngIf="motivoAplazamientoCD2.errors && (motivoAplazamientoCD2.dirty || motivoAplazamientoCD2.touched)">
                          <span *ngIf="motivoAplazamientoCD2.errors.required">Requerido</span>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-3 form-group" [ngClass]="{ 'text-danger': pazSalvo.invalid && pazSalvo.touched }">
                        <label class="col-form-label col-form-label-sm">Detalle paz y salvo (Deudor 1)</label>
                        <input type="text" class="form-control form-control-sm" [imask]="alphanumericMask"
                        [readonly]="!motivoAplazamiento.value?.includes('13')" [required]="motivoAplazamiento.value?.includes('13')" formControlName="pazSalvo">
                        <div *ngIf="pazSalvo.errors && (pazSalvo.dirty || pazSalvo.touched)">
                          <span *ngIf="pazSalvo.errors.required">Requerido</span>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-3 form-group" [ngClass]="{ 'text-danger': certificacionDesembargo.invalid && certificacionDesembargo.touched }">
                        <label class="col-form-label col-form-label-sm">Detalle certificación desembargo (Deudor 1)</label>
                        <input type="text" class="form-control form-control-sm" [imask]="alphanumericMask"
                        [readonly]="!motivoAplazamiento.value?.includes('14')" [required]="motivoAplazamiento.value?.includes('14')" formControlName="certificacionDesembargo">
                        <div *ngIf="certificacionDesembargo.errors && (certificacionDesembargo.dirty || certificacionDesembargo.touched)">
                          <span *ngIf="certificacionDesembargo.errors.required">Requerido</span>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-3 form-group" [ngClass]="{ 'text-danger': otros.invalid && otros.touched }">
                        <label class="col-form-label col-form-label-sm mt-auto">Otros (Deudor 1)<br></label>
                        <input type="text" class="form-control form-control-sm" [imask]="alphanumericMask"
                        [readonly]="!motivoAplazamiento.value?.includes('17')" [required]="motivoAplazamiento.value?.includes('17')" formControlName="otros">
                        <div *ngIf="otros.errors && (otros.dirty || otros.touched)">
                          <span *ngIf="otros.errors.required">Requerido</span>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-3 form-group" [ngClass]="{ 'text-danger': pazSalvoD2.invalid && pazSalvoD2.touched }">
                        <label class="col-form-label col-form-label-sm">Detalle paz y salvo (Deudor 2)</label>
                        <input type="text" class="form-control form-control-sm" [imask]="alphanumericMask"
                        [readonly]="!motivoAplazamientoD2.value?.includes('13')" [required]="motivoAplazamientoD2.value?.includes('13')" formControlName="pazSalvoD2">
                        <div *ngIf="pazSalvoD2.errors && (pazSalvoD2.dirty || pazSalvoD2.touched)">
                          <span *ngIf="pazSalvoD2.errors.required">Requerido</span>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-3 form-group" [ngClass]="{ 'text-danger': certificacionDesembargoD2.invalid && certificacionDesembargoD2.touched }">
                        <label class="col-form-label col-form-label-sm">Detalle certificación desembargo (Deudor 2)</label>
                        <input type="text" class="form-control form-control-sm" [imask]="alphanumericMask"
                        [readonly]="!motivoAplazamientoD2.value?.includes('14')" [required]="motivoAplazamientoD2.value?.includes('14')" formControlName="certificacionDesembargoD2">
                        <div *ngIf="certificacionDesembargoD2.errors && (certificacionDesembargoD2.dirty || certificacionDesembargoD2.touched)">
                          <span *ngIf="certificacionDesembargoD2.errors.required">Requerido</span>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-3 form-group" [ngClass]="{ 'text-danger': otrosD2.invalid && otrosD2.touched }">
                        <label class="col-form-label col-form-label-sm mt-auto">Otros (Deudor 2)<br></label>
                        <input type="text" class="form-control form-control-sm" [imask]="alphanumericMask"
                        [readonly]="!motivoAplazamientoD2.value?.includes('17')" [required]="motivoAplazamientoD2.value?.includes('17')" formControlName="otrosD2">
                        <div *ngIf="otrosD2.errors && (otrosD2.dirty || otrosD2.touched)">
                          <span *ngIf="otrosD2.errors.required">Requerido</span>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-3 form-group" [ngClass]="{ 'text-danger': pazSalvoCD1.invalid && pazSalvoCD1.touched }">
                        <label class="col-form-label col-form-label-sm">Detalle paz y salvo (Codeudor 1)</label>
                        <input type="text" class="form-control form-control-sm" [imask]="alphanumericMask"
                        [readonly]="!motivoAplazamientoCD1.value?.includes('13')" [required]="motivoAplazamientoCD1.value?.includes('13')" formControlName="pazSalvoCD1">
                        <div *ngIf="pazSalvoCD1.errors && (pazSalvoCD1.dirty || pazSalvoCD1.touched)">
                          <span *ngIf="pazSalvoCD1.errors.required">Requerido</span>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-3 form-group" [ngClass]="{ 'text-danger': certificacionDesembargoCD1.invalid && certificacionDesembargoCD1.touched }">
                        <label class="col-form-label col-form-label-sm">Detalle certificación desembargo (Codeudor 1)</label>
                        <input type="text" class="form-control form-control-sm" [imask]="alphanumericMask"
                        [readonly]="!motivoAplazamientoCD1.value?.includes('14')" [required]="motivoAplazamientoCD1.value?.includes('14')" formControlName="certificacionDesembargoCD1">
                        <div *ngIf="certificacionDesembargoCD1.errors && (certificacionDesembargoCD1.dirty || certificacionDesembargoCD1.touched)">
                          <span *ngIf="certificacionDesembargoCD1.errors.required">Requerido</span>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-3 form-group" [ngClass]="{ 'text-danger': otrosCD1.invalid && otrosCD1.touched }">
                        <label class="col-form-label col-form-label-sm mt-auto">Otros (Codeudor 1)<br></label>
                        <input type="text" class="form-control form-control-sm" [imask]="alphanumericMask"
                        [readonly]="!motivoAplazamientoCD1.value?.includes('17')" [required]="motivoAplazamientoCD1.value?.includes('17')" formControlName="otrosCD1">
                        <div *ngIf="otrosCD1.errors && (otrosCD1.dirty || otrosCD1.touched)">
                          <span *ngIf="otrosCD1.errors.required">Requerido</span>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-3 form-group" [ngClass]="{ 'text-danger': pazSalvoCD2.invalid && pazSalvoCD2.touched }">
                        <label class="col-form-label col-form-label-sm">Detalle paz y salvo (Codeudor 2)</label>
                        <input type="text" class="form-control form-control-sm" [imask]="alphanumericMask"
                        [readonly]="!motivoAplazamientoCD2.value?.includes('13')" [required]="motivoAplazamientoCD2.value?.includes('13')" formControlName="pazSalvoCD2">
                        <div *ngIf="pazSalvoCD2.errors && (pazSalvoCD2.dirty || pazSalvoCD2.touched)">
                          <span *ngIf="pazSalvoCD2.errors.required">Requerido</span>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-3 form-group" [ngClass]="{ 'text-danger': certificacionDesembargoCD2.invalid && certificacionDesembargoCD2.touched }">
                        <label class="col-form-label col-form-label-sm">Detalle certificación desembargo (Codeudor 2)</label>
                        <input type="text" class="form-control form-control-sm" [imask]="alphanumericMask"
                        [readonly]="!motivoAplazamientoCD2.value?.includes('14')" [required]="motivoAplazamientoCD2.value?.includes('14')" formControlName="certificacionDesembargoCD2">
                        <div *ngIf="certificacionDesembargoCD2.errors && (certificacionDesembargoCD2.dirty || certificacionDesembargoCD2.touched)">
                          <span *ngIf="certificacionDesembargoCD2.errors.required">Requerido</span>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-3 form-group" [ngClass]="{ 'text-danger': otrosCD2.invalid && otrosCD2.touched }">
                        <label class="col-form-label col-form-label-sm mt-auto">Otros (Codeudor 2)<br></label>
                        <input type="text" class="form-control form-control-sm" [imask]="alphanumericMask"
                        [readonly]="!motivoAplazamientoCD2.value?.includes('17')" [required]="motivoAplazamientoCD2.value?.includes('17')" formControlName="otrosCD2">
                        <div *ngIf="otrosCD2.errors && (otrosCD2.dirty || otrosCD2.touched)">
                          <span *ngIf="otrosCD2.errors.required">Requerido</span>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-3 form-group" [ngClass]="{ 'text-danger': observaciones.invalid && observaciones.touched }">
                        <label class="col-form-label col-form-label-sm">Observaciones</label>
                        <textarea class="form-control form-control-sm" formControlName="observaciones" required (blur)="saveForm(forma, formIdentifier)"></textarea>
                        <div *ngIf="observaciones.errors && (observaciones.dirty || observaciones.touched)">
                          <span *ngIf="observaciones.errors.required">Requerido</span>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-3 form-group">
                        <label class="col-form-label col-form-label-sm">Fecha envío carta respuesta estudio</label>
                        <div class="input-group">
                            <input type="text" class="form-control form-control-sm text-center" placeholder="Día/Mes/Año"
                            ngbDatepicker #d2="ngbDatepicker" (click)="d2.toggle()"  formControlName="fechaEnvioCarta" disabled/>
                            <button class="btn btn-info btn-sm" (click)="d2.toggle()" type="button" disabled>
                                <i class="fa fa-calendar"></i>
                            </button>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-3 form-group">
                        <label class="col-form-label col-form-label-sm">Usuario</label>
                        <!-- [(ngModel)]="capacidad.petition.userName" -->
                        <input type="text" class="form-control form-control-sm" formControlName="usuario" [disabled]="true" readonly>
                    </div>
                </div>
            </div>
            <!-- <div class="card-header" role="tab" id="tituloInmaterializado" data-toggle="collapse"
                data-target="#infoInmaterializado" aria-expanded="false" aria-controls="infoInmaterializado">
                <h4 class="mb-0">Generacion Pagaré Inmaterializado</h4>
            </div>
            <div id="infoInmaterializado" class="card-body collapse show" role="tabpanel"
                aria-labelledby="tituloInmaterializado">
                <div class="row justify-content-center">
                    <div class="col-sm-12 col-md-4 col-lg-3 form-group">
                        <label class="col-form-label col-form-label-sm">Fecha Firma</label>
                        <div class="input-group">
                            <input class="form-control form-control-sm text-center" type="text" placeholder="Día/Mes/Año"
                            ngbDatepicker #d2="ngbDatepicker" (click)="d2.toggle()" formControlName="fechaFirma" disabled/>
                            <button class="btn btn-info btn-sm" (click)="d2.toggle()" type="button" disabled>
                                <i class="fa fa-calendar"></i>
                            </button>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-4 col-lg-3 form-group">
                        <label class="col-form-label col-form-label-sm">Consecutivo Pagaré</label>
                        <input type="text" class="form-control form-control-sm" formControlName="consecutivoPagare" disabled>
                    </div>
                    <div class="col-sm-12 col-md-4 col-lg-3 form-group">
                        <label class="col-form-label col-form-label-sm">Firmas del Pagaré</label>
                        <input type="text" class="form-control form-control-sm" formControlName="firmasPagare" disabled>
                    </div>
                </div>
            </div> -->
        </form>
        <!-- Separador -->
        <div class="row justify-content-center">
            <hr style="width: 90%; margin-bottom: 1.45rem;">
        </div>
        <!-- Boton Continuar -->
        <div class="row justify-content-center text-center">
            <!-- <span *ngIf="segForm.form.invalid && segForm.submitted"
                class="alert alert-danger font-weight-bold text-uppercase">
                Faltan campos requeridos, verifique</span> -->
            <div class="col-sm-12 col-md-12 col-lg-12">
                <button type="button" class="btn btn-primary font-weight-bold m-2" title="Volver" [disabled]="formSubmitted" (click)="onBack()">
                    <i class="fas fa-arrow-left"></i>
                    Volver
                </button>
                <button class="btn btn-primary font-weight-bold m-2" type="button" (click)="onSave()" [disabled]="formSubmitted">
                    <i class="fa fa-save"></i>
                    Guardar
                </button>
                <button type="button" class="btn btn-primary font-weight-bold m-2" (click)="registrar()" title="Enviar" [disabled]="formSubmitted">
                    <i class="fas fa-paper-plane"></i>
                    Enviar
                </button>
            </div>
        </div>
    </div>
</div>

<ngx-spinner color="#c2af85" size="medium" type="ball-fussion">
    <p class='color-spinner-text'>Cargando... </p>
</ngx-spinner>
